// Germany
export const locale = {
  lang: 'de',
  data: {
    TRANSLATOR: {
      SELECT: 'Wähle deine Sprache',
    },
    SIDEBAR: {
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Settings',
      RIDES_CONFIG_GUEST_PHONES: 'Guest phones',
      RIDES_CONFIG_PROVIDERS: 'Providers',
      FACE_VERIFICATION_CONFIG: 'Face verification',
    },
    PAGES: {
      CORPORATION_OFFICE_DETAIL: {
        TITLE: 'Bürodetails',
        BACK_BUTTON: 'Zurück',
        TAB_OVERVIEW: 'Allgemeine Informationen',
        TAB_USERS: 'Zugewiesene Benutzer',
        GENERAL_INFORMATION: 'Allgemeine Informationen',
        ADDITIONAL_INFORMATION: 'Zusätzliche Informationen',
        CONTACT_PERSON: 'Kontaktperson',
        CONTACT_PHONE: 'Kontakttelefon',
        CONTACT_EMAIL: 'Kontakt-E-Mail',
        STATUS: 'Status',
        COMMERCIAL_ADDRESS: 'Geschäftsadresse',
        CITY: 'Stadt',
        POSTAL_CODE: 'Postleitzahl',
        LOADING: 'Büoinformationen werden geladen...',
        LOADING_USERS: 'Benutzer werden geladen...',
        ERROR: 'Fehler',
        USERS: 'Benutzer',
        USER_NAME: 'Name',
        USER_EMAIL: 'E-Mail',
        USER_PHONE: 'Telefon',
        USER_CORPORATE_EMAIL: 'Unternehmens-E-Mail',
        USER_PERSONAL_EMAIL: 'Persönliche E-Mail',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: 'Abteilung',
        USER_CORPORATE_PHONE: 'Unternehmenstelefon',
        USER_CONFIRMED: 'Bestätigt',
        USER_ROLE: 'Rolle',
        OFFICE_CODE: 'Bürocode',
        CORPORATION: 'Unternehmen',
        CREATED_AT: 'Erstellt:',
        UPDATED_AT: 'Aktualisiert:',
        NO_USERS: 'Keine Benutzer in diesem Büro',
        WAIIS_LINK: 'In WAIIS anzeigen',
        DELETE_USER: 'Löschen',
        DELETE_CONFIRMATION: 'Möchten Sie diesen Benutzer wirklich löschen?',
        DELETE_CONFIRM_BUTTON: 'Ja, löschen',
        DELETE_CANCEL_BUTTON: 'Abbrechen',
        ACTIONS: 'Aktionen',
        EDIT_USER: 'Benutzer bearbeiten',
        ADD_USER: 'Benutzer hinzufügen',
        REQUIRED_FIELDS: 'Erforderliche Felder',
        OPTIONAL_FIELDS: 'Optionale Felder (mindestens eine erforderlich)',
        NAME: 'Name',
        SURNAME: 'Nachname',
        DEPARTMENT: 'Abteilung',
        CORPORATE_EMAIL: 'Unternehmens-E-Mail',
        PERSONAL_EMAIL: 'Persönliche E-Mail',
        DNI: 'DNI',
        CORPORATE_PHONE: 'Unternehmenstelefon',
        PERSONAL_PHONE: 'Persönliches Telefon',
        CONFIRMED: 'Bestätigt',
        STATUS_PENDING: 'Ausstehend',
        STATUS_REJECTED: 'Abgelehnt',
        STATUS_ACCEPTED: 'Akzeptiert',
        STATUS_ACTIVE: 'Aktiv',
        STATUS_INACTIVE: 'Inaktiv',
        CANCEL: 'Abbrechen',
        SAVE_USER: 'Benutzer speichern',
        UPDATE_USER: 'Benutzer aktualisieren',
        WAIT: 'Warte',
        UPLOAD_CSV: 'CSV hochladen',
        UPLOADING: 'Wird hochgeladen...',
        LINK_USERS: 'Benutzer verknüpfen',
        LINKING: 'Wird verknüpft...',
        ERROR_REQUIRED_FIELD: 'Erforderliches Feld',
        ERROR_INVALID_EMAIL: 'Ungültige E-Mail',
        ERROR_MIN_LENGTH: 'Mindestens 2 Zeichen erforderlich',
        ERROR_INVALID_FIELD: 'Feld ist ungültig',
      },
    },
    MENU: {
      NEW: 'Neu',
      ACTIONS: 'Aktionen',
      CREATE_POST: 'Erstellen Sie einen neuen Beitrag',
      PAGES: 'Pages',
      FEATURES: 'Eigenschaften',
      APPS: 'Apps',
      DASHBOARD: 'Instrumententafel',
    },
    AUTH: {
      GENERAL: {
        OR: 'Oder',
        SUBMIT_BUTTON: 'einreichen',
        NO_ACCOUNT: 'Hast du kein Konto?',
        SIGNUP_BUTTON: 'Anmelden',
        FORGOT_BUTTON: 'Passwort vergessen',
        BACK_BUTTON: 'Zurück',
        PRIVACY: 'Privatsphäre',
        LEGAL: 'Legal',
        CONTACT: 'Kontakt',
      },
      LOGIN: {
        TITLE: 'Create Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Nutzername',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: 'Zugriff verweigert',
        MESSAGE: 'Sie haben keinen Zugriff auf diese Ressource.',
        CONFIRM: 'Verstanden',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    WAIIS: {
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Face verification',
          GENERAL_TITLE: 'General switch',
          KILL_SWITCH_WARNING: 'Emergency kill switch: when turned off, nobody is required to pass face verification.',
          ENABLED_LABEL: 'Face verification enabled',
          THRESHOLDS_TITLE: 'Rekognition thresholds',
          LIVENESS_THRESHOLD_LABEL: 'Liveness confidence threshold',
          LIVENESS_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          SIMILARITY_THRESHOLD_LABEL: 'Similarity threshold',
          SIMILARITY_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          REFERENCE_TITLE: 'Comparison reference',
          REFERENCE_TECALIS_LABEL: 'Tecalis selfie',
          REFERENCE_TECALIS_HINT: 'Always against the selfie Tecalis verified against the ID document',
          REFERENCE_ENROLLMENT_LABEL: 'Capture after near misses',
          REFERENCE_ENROLLMENT_HINT: 'First against the Tecalis selfie; after several near misses the liveness image is stored and later checks compare against it',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Minimum similarity of a near miss',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Number between 0 and 100 (decimals allowed). A Tecalis selfie with no detectable face also counts',
          ENROLLMENT_ATTEMPTS_LABEL: 'Near misses to store the capture',
          ENROLLMENT_ATTEMPTS_HINT: 'Whole number between 1 and 10, counting all the user\'s trips',
          UPDATED_AT_LABEL: 'Last modified',
          DISABLE_CONFIRM_TITLE: 'Turn off face verification?',
          DISABLE_CONFIRM_TEXT: 'Nobody will be required to pass face verification until it is turned back on.',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Settings could not be loaded',
          ERROR_SAVE: 'Changes could not be saved',
          ERROR_FORBIDDEN: 'You do not have permission to perform this action',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            INTEGER: 'The value must be an integer',
            RANGE: 'The value must be between 0 and 100',
            ATTEMPTS_RANGE: 'The value must be between 1 and 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          TITLE: 'Ride settings',
          VTC_LABEL: 'VTC enabled',
          VTC_HINT: 'Controls global availability of VTC rides in the app',
          VTC_CONFIRM_TITLE: 'Are you sure?',
          VTC_DISABLE_TEXT: 'Disabling VTC will hide the request-ride button in the app for all users',
          VTC_ENABLE_TEXT: 'Enabling VTC will show the request-ride button in the app again',
          VTC_SAVED: 'VTC updated',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          RIDE_PRODUCTS_ENABLED_LABEL: 'WAIIS products in estimates',
          RIDE_PRODUCTS_ENABLED_HINT: 'On: the WAIIS products are shown and, for each one, the cheapest provider. Off: the real product list of each visible provider is shown (e.g. for certifications).',
          COMMISSION_ENABLED_LABEL: 'Charge commission',
          COMMISSION_PERCENT_LABEL: 'Commission %',
          COMMISSION_PERCENT_HINT: 'Percentage between 0 and 100 (two decimals)',
          CANCELLATION_PENALTY_LABEL: 'Cancellation penalty %',
          CANCELLATION_PENALTY_HINT: 'Percentage between 0 and 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Real fee adjustment',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalculate the penalty using the provider\'s real fee',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          RECEIPT_ADJUSTMENT_LABEL: 'Receipt adjustment on completed rides',
          RECEIPT_ADJUSTMENT_HINT: 'Reconcile the difference against the amount charged when the provider receipt arrives',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          ADJUSTMENT_NEVER_ENABLED: 'Never enabled',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Could not load settings',
          ERROR_SAVE: 'Could not save changes',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            RANGE: 'Value must be between 0 and 100',
          },
        },
        GUEST_PHONES: {
          TITLE: 'Guest phones',
          EMPTY: 'No phones configured',
          TABLE: {
            PHONE_NUMBER: 'Phone number',
            ACTIVE: 'Active',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'Accept',
          },
          MODAL: {
            CREATE_TITLE: 'New guest phone',
            EDIT_TITLE: 'Edit guest phone',
          },
          FORM: {
            PHONE_NUMBER: 'Phone number',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'E.164 format: international prefix with + (e.g. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'Phone number is required',
            PHONE_FORMAT: 'Invalid format: use E.164 (+ and 7–15 digits)',
          },
          DELETE: {
            TITLE: 'Delete phone?',
            TEXT: '{{phone}} will be removed from the guest pool',
            CONFIRM: 'Yes, delete',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDERS: {
          TITLE: 'Providers and product mapping',
          RIDE_PRODUCTS: {
            TITLE: 'WAIIS products',
            HELP: 'These are the products the rider sees. Each provider maps one of its real products to every WAIIS product; the estimate shows the cheapest mapped provider.',
            ADD: 'Add WAIIS product',
            MOVE_UP: 'Move up',
            MOVE_DOWN: 'Move down',
            TABLE: {
              ORDER: 'Order',
              PRODUCT: 'Product',
              VISIBLE: 'Visible',
              ACTIONS: 'Actions',
            },
            MODAL: {
              NEW_TITLE: 'New WAIIS product',
              EDIT_TITLE: 'Edit WAIIS product',
              KEY: 'Key',
              KEY_HELP: 'Internal identifier in lowercase, digits and hyphens (e.g. go, premium-xl). It cannot be changed later.',
              DISPLAY_NAME: 'Name',
              IMAGE: 'Image',
              IMAGE_HELP: 'URL of the icon the rider sees',
              DESCRIPTION: 'Description',
              DESCRIPTION_HELP: 'Optional, per language. Only languages with text are stored.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'The key is required',
              KEY_FORMAT: 'Only lowercase letters, digits and hyphens (50 characters max)',
              DISPLAY_NAME_REQUIRED: 'The name is required',
            },
            CONFIRM: {
              DELETE_TITLE: 'Delete WAIIS product?',
              DELETE_TEXT: '"{{product}}" will be permanently deleted',
            },
            ERROR: {
              IN_USE: 'It cannot be deleted: there are still mappings pointing to it in {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Sample route for product discovery',
            HELP: 'Providers only reveal their products when estimating a trip, and the catalog changes by city. Pick an origin and destination in the city you want to query: the route is saved for the whole team.',
            PICKUP: 'Origin',
            DROPOFF: 'Destination',
          },
          DISCOVER: {
            BUTTON: 'Discover provider products',
            ADD_TAG: 'Use this key: ',
            PLACEHOLDER: 'Type the key or discover the provider products',
            EMPTY: 'No products discovered yet',
            CAPACITY: '{{capacity}} seats',
            MAPPED_TO: 'Already mapped to {{product}}',
            MAPPED_HIDDEN: 'Mapped and hidden',
            REFRESH: 'Query the provider again',
            ROUTE_USED: 'Sample route: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Set the sample route on the providers page to discover products',
            ERROR: {
              DISABLED: 'The provider is disabled on the server',
              UNAVAILABLE: 'The provider is not available right now',
              GENERIC: 'Provider products could not be discovered',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Add product',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            ACCEPT: 'Accept',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
          FORM: {
            DISPLAY_NAME: 'Custom name',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'This provider has no mapped products yet',
            RIDE_PRODUCTS: 'There are no WAIIS products configured',
          },
          TABLE: {
            PRODUCT_KEY: 'Provider product',
            RIDE_PRODUCT: 'WAIIS product',
            VISIBLE: 'Visible',
            ACTIONS: 'Actions',
          },
          MODAL: {
            NEW_PRODUCT: 'New product',
            EDIT_PRODUCT: 'Edit product',
            PRODUCT_KEY: 'Provider product',
            PRODUCT_KEY_HELP: 'Exact product name at the provider (e.g. UberX, Standard)',
            RIDE_PRODUCT: 'WAIIS product',
            RIDE_PRODUCT_PLACEHOLDER: 'Select a WAIIS product',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'Provider product is required',
            RIDE_PRODUCT_REQUIRED: 'WAIIS product is required',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Delete product?',
            DELETE_PRODUCT_TEXT: '"{{product}}" will be permanently deleted',
          },
          ERROR: {
            TITLE: 'Error',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Provider saved',
          },
        },
      },
      MATCH_REVIEW: {
        DRIVER: 'Fahrer',
        PASSENGER: 'Fahrgast',
        VERIFY: 'Verifizieren',
        SELECT_DRIVER: 'Wählen Sie einen Fahrer',
        SELECT_PASSENGER: 'Wählen Sie einen Fahrgast',
        DRIVER_DATA: 'Fahrerinformationen',
        PASSENGER_DATA: 'Fahrgastinformationen',
        ROUTE_MAP: 'Routenkarte',
        NO_DATA: 'Keine Daten verfügbar',
        ENTER_ROUTINE_IDS:
          'Geben Sie die Routine-IDs des Fahrers und des Fahrgasts ein, um die Routen auf der Karte anzuzeigen',
        LOADED: 'Geladen',
        USER: 'Benutzer',
        DISTANCE: 'Entfernung',
        DURATION: 'Dauer',
        PRICE: 'Preis',
        LOADING: 'Wird geladen',
        SHOW_HEXAGONS: 'Hexagone anzeigen',
        SHOW_MAP_HEXAGONS: 'Alle Hexagone der Karte anzeigen',
        SHOW_POLYLINE: 'Polylinie anzeigen',
        ADD_DRIVER: 'Fahrer hinzufügen',
        ADD_RIDER: 'Fahrgast hinzufügen',
        SELECT_ROUTINE: 'Klicken Sie hier, um eine Route hinzuzufügen',
        NAME: 'Name',
        LOCATIONS: 'Standorte',
        ERROR_LOADING_ROUTE: 'Fehler beim Laden der Route',
        SELECT_ROUTE_DETAILS:
          'Wählen Sie eine Route, um die Details anzuzeigen',
        COPY_PHP_PAYLOAD: 'PHP-Nutzlast kopieren',
        COPIED: 'Kopiert',
        CENTER: 'Zentrieren',
        H3_RESOLUTION: 'H3-Auflösung',
        HEXAGON_POINTS: 'Hexagon-Punkte',
        SIGNIFICANT_POINTS: 'Bedeutende Punkte',
        ALL_POINTS: 'Alle Punkte',
        ERROR: 'Fehler',
        MAPS_LOAD_ERROR: 'Fehler beim Laden von Google Maps',
        ENTER_DRIVER_ID: 'Bitte geben Sie eine Routine-ID des Fahrers ein',
        ENTER_PASSENGER_ID: 'Bitte geben Sie eine Routine-ID des Fahrgasts ein',
        ERROR_VERIFYING: 'Fehler beim Verifizieren der {{type}}-Routine',
        PICKUP: 'Abholen {{type}}',
        ORIGIN: 'Herkunft {{type}}',
        DROPOFF: 'Abgabe {{type}}',
        DESTINATION: 'Ziel {{type}}',
        DRIVER_TEXT: 'Fahrer',
        PASSENGER_TEXT: 'Fahrgast',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'H3-Index (Res {{res}})',
        LOADING_ROUTINE: 'Routine wird geladen...',
        UNKNOWN_ERROR: 'Unbekannter Fehler',
        SEARCH_RADIUS: 'Suchradius',
        RADIUS_PLACEHOLDER: 'Radius in Metern',
        FOUND: 'Gefunden',
        INTEREST_POINTS: 'interessante Punkte',
        NO_POINTS_FOUND:
          'Keine Interessenpunkte im angegebenen Radius gefunden',
        ERROR_FETCHING_POINTS: 'Fehler beim Abrufen von Interessenpunkten',
        SEARCH_INTEREST_POINTS: 'Nach Interessenpunkten suchen',
        CANCEL_SEARCH: 'Suche abbrechen',
        LOAD_FROM_FILE: 'Aus Datei laden',
        PROCESS_COMPLETE: 'Prozess abgeschlossen',
        CONFIRM: 'Bestätigen',
      },
    },
  },
};
